import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M32 27.2v12m0 7.3v2.4m.9-41.6L57.8 57a1 1 0 0 1-1 1.4H7.2a1 1 0 0 1-.9-1.4l25-49.8a1 1 0 0 1 1.7 0z"
	})
});
export default SvgAlertinline;
